export default __webpack_public_path__ + "static/media/cimb-color.5a3b67b6.svg";